// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-title h1{line-height:66px;text-transform:unset;margin-bottom:70px}@media screen and (max-width:1599px){.media-title,.media-title h1{margin-bottom:-20px}.media-title.content-title h1,.media-title.content-title h1 span{text-transform:unset}}@media screen and (max-width:1365px){.media-title h1{line-height:41px}}@media screen and (max-width:767px){.media-title h1{line-height:25px}}", ""]);
// Exports
module.exports = exports;
